var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { find, isEqual } from 'lodash';
import { default as AntRadio } from 'antd/lib/radio';
var AntRadioGroup = AntRadio.Group;

var RadioGroup = function (_super) {
  __extends(RadioGroup, _super);

  function RadioGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  RadioGroup.prototype.onChange = function (e) {
    var _a = this.props,
        name = _a.name,
        onChange = _a.onChange;

    if (onChange) {
      onChange(e.target.value, name);
    }
  };

  RadioGroup.prototype.componentWillReceiveProps = function (nextProps) {
    var name = nextProps.name,
        value = nextProps.value,
        options = nextProps.options,
        onChange = nextProps.onChange,
        defaultValueIndex = nextProps.defaultValueIndex;

    if (isEqual(this.props.options, options)) {
      return;
    }

    if (value) {
      if (!find(options, {
        id: value
      })) {
        onChange(undefined, name);
      }
    } else if (defaultValueIndex !== undefined) {
      onChange(options[defaultValueIndex].id, name);
    }
  };

  RadioGroup.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  RadioGroup.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        className = _a.className,
        style = _a.style,
        disabled = _a.disabled,
        options = _a.options;
    var radioGroupProps = {
      value: value,
      className: className,
      style: style,
      disabled: disabled,
      options: options.map(function (option) {
        return {
          label: option.name,
          value: option.id,
          disabled: option.disabled ? option.disabled : false
        };
      })
    };
    return React.createElement(AntRadioGroup, __assign({}, radioGroupProps, {
      onChange: this.onChange
    }));
  };

  return RadioGroup;
}(Component);

export { RadioGroup };